import { getPublicSiteSettings, PublicSiteSettings } from '../services/emailMarketingService';
import { cachedResource } from '../utils/cachedResource';
import { ResourceState, useCachedResource } from './useCachedResource';

/** A nyilvános cégadatok (SiteSettings: név, cím, adószám, e-mail, telefon) — egyetlen
 *  kérés oldalanként; az ÁSZF, a lábléc és a kapcsolat oldal innen olvas. */
export const siteInfoResource = cachedResource<PublicSiteSettings>(getPublicSiteSettings);

export const useSiteInfo = (): ResourceState<PublicSiteSettings> => useCachedResource(siteInfoResource);
